const TOLERANCE = 1e-14;

// FIXME: What does this do? draw scaled image based on the size of something?
export const drawImageProp = (
    ctx: CanvasRenderingContext2D,
    img: HTMLImageElement,
    x?: number,
    y?: number,
    width?: number,
    height?: number,
    offsetX?: number,
    offsetY?: number,
) =>
{
    width ??= ctx.canvas.width;
    height ??= ctx.canvas.height;
    x ??= 0;
    y ??= 0;

    // default offset is center
    offsetX ??= 1 / 2;
    offsetY ??= 1 / 2;

    // keep bounds [0.0, 1.0]
    offsetX = Math.max(0, Math.min(offsetX, 1));
    offsetY = Math.max(0, Math.min(offsetY, 1));

    const scale = Math.min(width / img.width, height / img.height);

    let newWidth = img.width * scale; // new prop. width
    let newHeight = img.height * scale; // new prop. height

    // Aspect Ratio of Image
    let ratio = 1;

    // FIXME: re-evaluate thes next 2 if statements. Do they need to be dependant on each other?

    // decide which gap to fill
    if (newWidth < width) ratio = width / newWidth;
    if (Math.abs(ratio-1) < TOLERANCE && newHeight < height) ratio = height / newHeight; // updated

    newWidth *= ratio;
    newHeight *= ratio;

    // calc source rectangle

    // no larger than image
    const calcWidth = Math.min(img.width, img.width / (newWidth / width));
    const calcHeight = Math.min(img.height, img.height / (newHeight / height));

    // no smaller than 0
    const calcX = Math.max(0, (img.width - calcWidth) * offsetX);
    const calcY = Math.max(0, (img.height - calcHeight) * offsetY); // no smaller than 0

    // fill image in dest. rectangle
    ctx.drawImage(img, calcX, calcY, calcWidth, calcHeight, x, y, width, height);
};
